// extracted by mini-css-extract-plugin
export default {"selects":"Selects_selects__-R20Q"};